window['static_pages#index'] = function () {
  $('#show_new_static_pages_link_form').click(function (e) {
    e.preventDefault()
    e.stopPropagation()
    $('#new_static_pages_link_form').slideDown('fast')
  })
}
